var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"cta-content"}},[_c('div',{staticClass:"container content_title"}),_c('CTABanner',{attrs:{"onlyBanner":true,"bannerData":{bannerText: 'See PK PROFILE', href:'/pk-data'}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }